// extracted by mini-css-extract-plugin
export default {"container":"VirtualList_container__WBr9r"};